<template>
  <timeline
    :timeline="timeline"
    :tiles="tileDetails"
    :read-only="!canEdit"
    :loading="loading"
    :default-tile-permission="permissions.canAccessCalendar"
    :config="{'report': {cloneAppointmentId: isRecurring ? id : null}}"
    anchor="dialog-menubar"
    model-name="appointment"
    @add-note="(note, done) => baseAddNote(note, done, id, timeline, true)"
    @update-note="(note, done) => baseUpdateNote(note, done, true)"
    @remove-note="(entryId, reference) => baseRemoveNote(entryId, reference, true)"
    @pin-note="(entryId, val, done, reference) => basePinNote(entryId, val, done, reference, true)"
    @save-attachments="(keepIds, removeObjs, done) => baseSaveAttachments(keepIds, removeObjs, done, id, timeline, true)"
    @remove-attachment="(entryId, key, reference) => baseRemoveAttachment(entryId, key, id, reference, true)"
    @pin-attachment="(entryId, val, key, done, reference) => basePinAttachment(entryId, val, key, done, id, reference, true)"
  />
</template>

<script>
import appointmentTimelineMethodsMixin from 'components/app/calendar/partials/mixins/appointmentTimelineMethodsMixin'

export default {
  mixins: [appointmentTimelineMethodsMixin],
  props: {
    id: {
      type: Number,
      required: true
    },
    isRecurring: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timeline: [],
      loading: false
    }
  },
  computed: {
    tileDetails () {
      return {
        'note': this.isRecurring ? 'Notes may be collated from clients or any previous appointments in the recurring rule' : true,
        'attachment': true,
        'log': true,
        'communication': true,
        'invoice': this.isRecurring ? 'Invoices may be collated from any previous appointments in the recurring rule' : true,
        'quotation': this.isRecurring ? 'Quotations may be collated from any previous appointments in the recurring rule' : true,
        'report': this.isRecurring ? 'Reports may be collated from any previous appointments in the recurring rule' : true
      }
    }
  },
  methods: {
    /* Get Timeline */
    async getTimeline () {
      this.loading = true
      const { status, payload } = await this.$get('v1/appointments/timeline', {
        id: this.id
      })
      this.loading = false
      if (status === 'success') {
        this.timeline = payload.timeline
      }
    }
  },
  mounted () {
    this.getTimeline()
  }
}
</script>
